import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const SuperAdmin = () => {
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;
 
    console.log("LocalStorage User Data:", user);
    console.log("User Role:", user?.role); 
 
    if (user && (user.role === 'super-admin' || user.user?.role === 'super-admin')) {
        return <Outlet />;
    }

    return <Navigate to="/admin/dashboard" replace />;
};

export default SuperAdmin;